/*
	Author: xowei <wei@xowei.tw>
	Website: https://xowei.tw/
*/

$(function () {
	var $body = $('body, html')
	var $hud = $('.hud')
	var $linkPosition
	var $navList = $('.nav-list')
	var $preload = $('.preload')
	var $nav = $('nav')
	var $window = $(window)
	var tab = 0
	var windowScroll = 0

	$hud.hide()

	$window.on('scroll', function () {
		windowScroll = $(window).scrollTop()

		if (windowScroll < window.innerHeight) {
			if ($hud.length) $hud.hide()
		} else {
			if ($hud.length) $hud.show()
		}
	})

	$(window).load(function () {
		$preload.fadeOut()
		// adjustBodyHeight()
	})

	// if (getQS() !== undefined) tab = getQS()
	// init($('[data-id="' + tab + '"]').data('url'))

	// $('[data-id="' + tab + '"]')
	// 	.parent()
	// 	.addClass('active')

	// $navList.on('click', 'li > a', function () {
	// 	tab = $(this).data('id')
	// 	init($('[data-id="' + tab + '"]').data('url'))
	// 	$(this).parent().addClass('active').siblings().removeClass('active')

	// 	if (tab !== 0) changeURL('?s=' + tab)
	// 	else changeURL('')
	// })

	navLinkClick('#navContent a')
	smoothScroll('.nav-menu-item a[href^="#"]')
	smoothScroll('#gototop')
	initAnimate()
	initLazyLoadImage()
	initProcessSwitch()
	initDetectDevice()
	initNav()
})

$(window).on('resize', function () {
	// adjustBodyHeight()
})

function getQS() {
	var url = location.href

	if (url.indexOf('?') != -1) {
		var s = ''
		var ary = url.split('?')[1].split('&')
		for (i = 0; i <= ary.length - 1; i++) {
			if (ary[i].split('=')[0] == 's') {
				s = ary[i].split('=')[1]
			}
		}
	}

	return s
}

function changeURL(url) {
	window.history.pushState({}, 0, '//' + window.location.host + window.location.pathname + url)
}

function init(url) {
	var $preload = $('.preload')

	$.ajax({
		url: url,
		cache: false,
		beforeSend: function () {
			$preload.show()
		},
		complete: function () {
			$preload.hide()
		},
	}).done(function (html) {
		var tab = url.split('.')[0]
		var menuData = {}
		var parsedHTML = $.parseHTML(html)
		console.log('parsedHTML', parsedHTML)
		var $replacedNav = parsedHTML[1].innerHTML
		var $replacedBanner = parsedHTML[3].innerHTML
		var $replacedContent = parsedHTML[5].innerHTML
		$('#navContent').html($replacedNav)
		$('#bannerContent').removeClass('milano gr').addClass(tab).html($replacedBanner)
		$('#content').html($replacedContent)
		$('#content .customers').removeClass('milano gr').addClass(tab)

		document.title = tab == 'gr' ? '米蘭絕色蜜粉餅2021 「知的幸福」 GR' : '米蘭絕色蜜粉餅2021 「知的幸福」'
		document.title = document.title + ' - Kanebo'

		$('.menuChanger').find('a span.series').text(menuData.title)

		$('body, html').scrollTop(0)
		navLinkClick('#navContent a')
		smoothScroll('#navContent a')

		initAnimate()
		initLazyLoadImage()
	})

	// adjustBodyHeight()
}

function navChange() {
	$('#navmenu').on('change', function () {
		if ($('#navmenu').is(':checked')) {
			$('body').css('overflow-y', 'hidden')
		} else {
			$('body').css('overflow-y', 'scroll')
		}
	})
}

function navLinkClick(target) {
	$(target).on('click', function () {
		if ($(this).attr('role') == 'dropdown') {
			$(this).toggleClass('list-open')
			$(this).siblings('ul').toggleClass('is-hidden')
		} else {
			$('.nav-icon').click()
		}
	})
}

function smoothScroll(target) {
	var $body = $('body, html')
	var $linkPosition
	var $nav = $('nav')

	$(target).each(function () {
		var $link = $(this)
		$linkPosition

		$link.on('click', function (e) {
			e.preventDefault()
			var tab = $link.attr('role')

			if (!tab) {
				var $target = $($(this).attr('href'))
				$iconHeight = $('.product-title .icon').height()
				$linkPosition = ($target.length ? $target.offset().top : 0) - $nav.height()

				if ($target.is(':not(":first-child")')) {
					$linkPosition -= $iconHeight / 2
				}

				$body.animate({
					scrollTop: $linkPosition,
				})
			}
		})
	})
}

function adjustBodyHeight() {
	var space = $('nav').height()
	$('body').css('margin-top', space - 1)
}

function initAnimate() {
	$('.product-text-cta').each(function () {
		$(this).attr({
			'data-aos': 'fade-in',
		})
	})

	$('.product-text-logo, .product-title, .product-subtitle, .product-slogan, .product-limited, .product-text-title, .product-text-price, .customers-title, .process-cta, .product-features, .method').each(function () {
		$(this).attr({
			'data-aos': 'fade-up',
		})
	})

	$('.product_a1 .product-image').each(function () {
		$(this).attr({
			'data-aos': 'fade-left',
		})
	})

	$('.product_a2 .product-image').each(function () {
		$(this).attr({
			'data-aos': 'fade-right',
		})
	})

	$('.product-text-list li').each(function () {
		let delay = 200 * $(this).index()

		$(this).attr({
			'data-aos': 'fade-up',
			'data-aos-delay': delay,
		})
	})

	$('.location-list').each(function () {
		$(this).attr({
			'data-aos': 'fade-in',
			'data-aos-delay': 500,
		})
	})

	$('.process-item').each(function () {
		let delay = 200 * $(this).index()

		$(this).find('.process-deco').attr({
			'data-aos': 'fade-in',
			'data-aos-delay': delay,
		})

		delay = delay + 200

		$(this).find('.process-image > *').attr({
			'data-aos': 'fade-up',
			'data-aos-delay': delay,
		})

		delay = delay + 200

		$(this).find('.process-text-title').attr({
			'data-aos': 'fade-up',
			'data-aos-delay': delay,
		})

		delay = delay + 200

		$(this).find('.process-text-name').attr({
			'data-aos': 'fade-up',
			'data-aos-delay': delay,
		})

		delay = delay + 200

		$(this).find('.process-text-info').attr({
			'data-aos': 'fade-up',
			'data-aos-delay': delay,
		})

		delay = delay + 200

		$(this).find('.process-text-notes').attr({
			'data-aos': 'fade-up',
			'data-aos-delay': delay,
		})
	})

	$('.customer').each(function () {
		let delay = 200 * $(this).index()

		$(this).find('.customer-name').attr({
			'data-aos': 'fade-up',
			'data-aos-delay': delay,
		})

		delay = delay + 200

		$(this).find('.customer-title').attr({
			'data-aos': 'fade-up',
			'data-aos-delay': delay,
		})

		delay = delay + 200

		$(this).find('.customer-content').attr({
			'data-aos': 'fade-up',
			'data-aos-delay': delay,
		})

		delay = delay + 200

		$(this).find('.customer-cta').attr({
			'data-aos': 'fade-up',
			'data-aos-delay': delay,
		})

		delay = delay + 200

		$(this)
			.find('.customer-image')
			.attr({
				'data-aos': $(this).index() % 2 === 0 ? 'fade-left' : 'fade-right',
				'data-aos-delay': delay,
			})
	})

	$('.location .container > div').each(function () {
		let delay = 200 * $(this).index()

		$(this).attr({
			'data-aos': 'fade-up',
			'data-aos-delay': delay,
		})
	})

	AOS.init({
		duration: 1000,
		once: true,
	})
}

function initSvg() {
	$('.svg').each(function () {
		var $img = $(this)
		var imgID = $img.attr('id')
		var imgClass = $img.attr('class')
		var imgURL = $img.attr('src')
		// console.log($img)

		$.get(
			imgURL,
			function (data) {
				// console.log({
				// 	data,
				// })
				// Get the SVG tag, ignore the rest
				var $svg = $(data).find('svg')

				// Add replaced image's ID to the new SVG
				if (typeof imgID !== 'undefined') {
					$svg = $svg.attr('id', imgID)
				}
				// Add replaced image's classes to the new SVG
				if (typeof imgClass !== 'undefined') {
					$svg = $svg.attr('class', imgClass + ' replaced-svg')
				}

				// Remove any invalid XML tags as per http://validator.w3.org
				$svg = $svg.removeAttr('xmlns:a')

				// Replace image with new SVG
				$img.replaceWith($svg)
			},
			'xml'
		)
	})
}

function initLazyLoadImage() {
	!(function (window) {
		var $q = function (q, res) {
				if (document.querySelectorAll) {
					res = document.querySelectorAll(q)
				} else {
					var d = document,
						a = d.styleSheets[0] || d.createStyleSheet()
					a.addRule(q, 'f:b')
					for (var l = d.all, b = 0, c = [], f = l.length; b < f; b++) l[b].currentStyle.f && c.push(l[b])

					a.removeRule(0)
					res = c
				}
				return res
			},
			addEventListener = function (evt, fn) {
				window.addEventListener
					? this.addEventListener(evt, fn, false)
					: window.attachEvent
					? this.attachEvent('on' + evt, fn)
					: (this['on' + evt] = fn)
			},
			_has = function (obj, key) {
				return Object.prototype.hasOwnProperty.call(obj, key)
			}
		function loadImage(el, fn) {
			var img = new Image(),
				src = el.getAttribute('data-src')
			img.onload = function () {
				if (!!el.parent) el.parent.replaceChild(img, el)
				else el.src = src

				fn ? fn() : null
			}
			img.src = src
		}

		function elementInViewport(el) {
			var offset = 200
			var rect = el.getBoundingClientRect()
			// console.log(rect)

			return (
				rect.top >= 0 &&
				rect.left >= 0 &&
				rect.top <= (window.innerHeight || document.documentElement.clientHeight) + offset
			)
		}

		var images = new Array(),
			query = $q('img.lazy'),
			processScroll = function () {
				for (var i = 0; i < images.length; i++) {
					if (elementInViewport(images[i])) {
						loadImage(images[i], function () {
							images.splice(i, i)
						})
					}
				}
			}
		for (var i = 0; i < query.length; i++) {
			images.push(query[i])
		}

		processScroll()
		addEventListener('scroll', processScroll)
	})(this)
}

function initProcessSwitch() {
	let timer
	let speed = 2000
	let timerIsPause = false
	let currentTarget = 0
	let $switch = $('.process-switch')
	let $items = $switch.nextAll()

	$switch.on({
		mouseenter: function () {
			timerIsPause = true
		},
		mouseleave: function () {
			timerIsPause = false
		},
	})

	$items.on({
		mouseenter: function () {
			timerIsPause = true
		},
		mouseleave: function () {
			timerIsPause = false
		},
	})

	$items.each(function () {
		const $item = $(this)
		const index = $item.index() - 1

		$item.on('click', function () {
			$switch.find('.process-switch-button').eq(index).click()
		})
	})

	$switch.find('.process-switch-button').each(function () {
		const $button = $(this)
		const index = $button.index()

		$button.on('click', function () {
			$switch.find('.process-switch-button').removeClass('active')
			$button.addClass('active')

			$items.each(function () {
				$(this).removeClass('active')
			})

			$items.eq(index).addClass('active')
		})
	})

	timer = setInterval(function () {
		if (!timerIsPause) {
			currentTarget += 1

			if (currentTarget >= $items.length) currentTarget = 0
			$switch.find('.process-switch-button').eq(currentTarget).click()
		}
	}, speed)
}

function initDetectDevice() {
	var classNames = []
	if (navigator.userAgent.match(/(iPad|iPhone|iPod)/i)) classNames.push('device-ios')
	if (navigator.userAgent.match(/android/i)) classNames.push('device-android')
	if (navigator.userAgent.match(/Firefox/i)) classNames.push('device-firefox')
	if (navigator.userAgent.match(/Edg/i)) classNames.push('device-edge')
	if (navigator.userAgent.match(/Chrome/i)) classNames.push('device-chrome')

	var html = document.getElementsByTagName('html')[0]

	if (classNames.length) classNames.push('on-device')
	if (html.classList) html.classList.add.apply(html.classList, classNames)
}

function initNav () {
	$('.nav-menu-item a[href^="#"]').on('click', function () {
		console.log('click');
		$('.menu-toggle--open').click();
	})
}
